<template>
  <Modal @close="$emit('close')">
    <h3 class="modalTitle">
      Similar laptops
    </h3>
    <h6>Select laptop you would like to replace with</h6>
    <div class="content">
      <div v-for="laptop in laptopsSortedBySimilarity" :key="laptop.id" class="laptopSimilar">
        <RecordLaptop hideActions isChecked :laptop="laptop">
          <div slot="recordLeftSide" class="recordLeftSide">
            <Field
              type="radio"
              :value="laptopSelectedId === laptop.id"
              @update:value="(value) => selectLaptop(value ? laptop.id : null)" />
          </div>
        </RecordLaptop>
      </div>
    </div>
    <Btn class="replace danger" :disabled="!laptopSelectedId" @click="$emit('replace', laptopSelectedId)">
      Replace
    </Btn>
  </Modal>
</template>

<script>
import RecordLaptop from '@components/RecordLaptop'
import { actions } from '@utils'
import { pluckId } from '@utils/collections'
import sortLaptopsBySimilarity from '../utils/sortLaptopsBySimilarity'

export default {
  components: { RecordLaptop },
  props: {
    laptops: Array,
    laptopToBeReplaced: Object,
  },
  data() {
    return {
      laptopSelectedId: this.laptops[0].id,
    }
  },
  computed: {
    laptopsSortedBySimilarity() {
      return sortLaptopsBySimilarity(this.laptopToBeReplaced, this.laptops)
        .slice(0, 10)
    },
  },
  methods: {
    selectLaptop(laptopId) {
      this.laptopSelectedId = laptopId
    },
    ...actions(
      'FETCH_MISSING_FILE',
    ),
  },
  mounted() {
    const imageIds = pluckId('imageFileId', this.laptopsSortedBySimilarity)

    this.FETCH_MISSING_FILE(imageIds)
  },
}
</script>

<style lang="scss">
.Modal {
  .Modal-box {
    h3.modalTitle {
      margin-bottom: 0.5rem;
      padding: 1rem 1rem 0;
    }

    h6 {
      color: $grey;
      padding: 0 0 1rem 1rem;
    }

    .content {
      max-height: 40rem;
      overflow-y: scroll;
      padding: 0 2rem 2rem;
    }

    .RecordLaptop {
      margin-bottom: 0;
    }

    .laptopSimilar {
      margin-bottom: 1.5rem;

      .recordLeftSide {
        align-items: center;
        border-right: 1px solid $border-color-light;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-right: 1rem;
        min-height: 100%;
        padding-right: 1rem;
      }
    }

    .LaptopImage {
      display: flex;
      justify-content: center;

      img {
        max-width: 20rem;
      }
    }
  }
}
</style>
